import CustomizableProductsBrandFulfillmentPage from "@faire/prototype-playground/workspace/vsi/customizable-products-brand-fulfillment";
import CustomizableProductsM2Page from "@faire/prototype-playground/workspace/vsi/customizable-products-m-2";
import PdpCustomizationOptionsPage from "@faire/prototype-playground/workspace/vsi/pdp-customization-options";
import { Route, Switch } from "react-router-dom";

export function VaibhavSinghRoutes() {
  return (
    <Switch>
      <Route
        path="/vsi/customizable-products-m-2"
        component={CustomizableProductsM2Page}
      />
      <Route
        path="/vsi/customizable-products-brand-fulfillment"
        component={CustomizableProductsBrandFulfillmentPage}
      />
      <Route
        path="/vsi/pdp-customization-options"
        component={PdpCustomizationOptionsPage}
      />
    </Switch>
  );
}

export const slug = "vsi";
